import React from "react";
import { object, array } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { Link } from "@quintype/components";

import CarouselSlider from "../../molecules/carousel-slider";
import CustomHeadline from "../../molecules/custom-headline/index";
import DfpAd from "../../dfp-ad";

import { getSlug } from "../../utils";

import "./photos.m.css";

const trimCollection = collection => {
  const trimmedCollection = Object.assign({}, collection);
  trimmedCollection["items"] = trimmedCollection.items.slice(0, 10);
  return trimmedCollection;
};

const PhotosRow = ({ collection, sections, config }) => {
  const slug = getSlug(collection, sections);
  const trimmedCollection = trimCollection(collection);
  const name = config["page-type"] === "home-page" ? "Photos" : collection.name;

  return collection.items.length > 4 ? (
    <div styleName="wrapper">
      <div styleName="title-wrapper">
        <CustomHeadline text={name} color="white" headerType={9} href={slug} />
        <Link className="read-more" href={slug}>
          <span>See More Stories</span>
        </Link>
      </div>
      <CarouselSlider collection={trimmedCollection} widths={[540]} />

      <div styleName="dfp-ad-728x90">
        <DfpAd adtype="FPJ_Homepage_Bottom_728x90" />
      </div>
    </div>
  ) : null;
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

PhotosRow.propTypes = {
  collection: object,
  sections: array,
  config: object
};

export default connect(
  mapStateToProps,
  null
)(PhotosRow);
